if (!window.location.pathname.includes("cart")) {

  let counter = 0;

  const interval = setInterval(() => {

    const cartDrawer = document.querySelector("cart-drawer");
    const target = document.querySelector("[bss-b2b-cart-total-price]");

    if (window.BSS_B2B && cartDrawer && target) {

      const insertElement = () => {
        const el = document.querySelector("[bss-b2b-cart-total-price]");
        if (!el) return;

        if (el.querySelector(".bss-currency")) return;

        const span = document.createElement("span");
        span.className = "bss-currency";
        span.innerText = "USD";
        span.style.marginRight = "4px";

        el.insertBefore(span, el.firstChild);
      };

      insertElement();

      const observer = new MutationObserver(() => {
        insertElement();
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });

      clearInterval(interval);

    } else {
      counter += 100;
      if (counter >= 10000) clearInterval(interval);
    }

  }, 100);
}

document.addEventListener("click", function (e) {

  // const qtyBtn = e.target.closest(".quantity__button");
  // if (!qtyBtn) return;

  // const priceEl = document.querySelector("[bss-b2b-cart-total-price]");
  // if (!priceEl) return;

  // priceEl.style.transition = "opacity 0.2s ease";
  // priceEl.style.opacity = "0";

  // setTimeout(() => {

  //   const newEl = document.querySelector("[bss-b2b-cart-total-price]");
  //   if (newEl) {
  //     newEl.style.opacity = "1";
  //   }

  // }, 200);

});

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 

// document.addEventListener("bss_b2b:CustomCartUpdate", e => {
//   BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
// })